<div class="back">
    <img src="./../../../assets/arrow.svg" alt="img" />
    <p>{{ text }}</p>
</div>
